import { useState } from 'react';
import { FaTimes, FaChevronDown } from 'react-icons/fa';

export const MultiSelect = ({ options, selected, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (option) => {
    const isSelected = selected.some(s => s.value === option.value);
    if (isSelected) {
      onChange(selected.filter(s => s.value !== option.value));
    } else {
      onChange([...selected, option]);
    }
  };

  const removeItem = (option, e) => {
    e.stopPropagation();
    onChange(selected.filter(s => s.value !== option.value));
  };

  return (
    <div className="relative">
      <div
        className="min-h-[38px] border border-gray-300 rounded px-3 py-2 cursor-pointer bg-white hover:border-gray-400 transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        {selected.length === 0 ? (
          <span className="text-gray-400">{placeholder}</span>
        ) : (
          <div className="flex flex-wrap gap-1">
            {selected.map(item => (
              <span
                key={item.value}
                className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 px-2 py-0.5 rounded text-sm"
              >
                {item.label}
                <button
                  onClick={(e) => removeItem(item, e)}
                  className="hover:text-blue-900"
                >
                  <FaTimes size={10} />
                </button>
              </span>
            ))}
          </div>
        )}
        <FaChevronDown
          className={`absolute right-3 top-3 text-gray-400 transition-transform ${
            isOpen ? 'rotate-180' : ''
          }`}
          size={12}
        />
      </div>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute z-20 w-full mt-1 bg-white border border-gray-300 rounded shadow-lg max-h-60 overflow-y-auto">
            {options.length === 0 ? (
              <div className="px-3 py-2 text-gray-500 text-sm">No options available</div>
            ) : (
              options.map(option => {
                const isSelected = selected.some(s => s.value === option.value);
                return (
                  <div
                    key={option.value}
                    className={`px-3 py-2 cursor-pointer hover:bg-gray-100 flex items-center gap-2 ${
                      isSelected ? 'bg-blue-50' : ''
                    }`}
                    onClick={() => handleToggle(option)}
                  >
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => {}}
                      className="w-4 h-4"
                    />
                    <span className="text-sm">{option.label}</span>
                  </div>
                );
              })
            )}
          </div>
        </>
      )}
    </div>
  );
};